import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import initConfig from "../CsdPublic/initConfig";
import { allBaseUrl } from "@/config/apiDomain";
import { AppConfig } from "@/utils/constant";
import { onMounted } from "vue";

import publicStore from "@/store/publicStore";
import { CallbackID } from "@/MessageHandler";
import { setStorage } from "@/utils/storage";
import { storeToRefs } from "pinia";
import { ElMessage } from "element-plus";
// import vConsole from "vconsole";
//
// const vc = new vConsole();


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const config = {
  soft_id: AppConfig.soft_id,
  os: AppConfig.os,
  curr_ver: AppConfig.curr_ver,
  wxLoginAndPayDomain: allBaseUrl.qnwApi.url,
  qnwProjectDomain: allBaseUrl.qnwApi.url,
};

initConfig(config);

onMounted(() => {
  (window as any).getCppMessage = handleCppMessage;

  //启动之后，发送指令
  (window as any).mbQuery(CallbackID.SET_TOKEN, "", null);
});

const handleTokenCmd = (data) => {
  if (!data.token) return;
  setStorage("token", data.token);
  const store = publicStore();
  const { isLogin } = storeToRefs(store);
  isLogin.value = true;
  console.log("handleTokenCmd token", data.token);
};

const handleSize = (data) => {
  // const { height, width } = data;
  //
  // const routerElement = document.getElementById("router");
  // routerElement!.style.setProperty("width", `${width}px`, "important");
  // routerElement!.style.setProperty("height", `${height}px`, "important");
};

const fixJsonString = (msg: string): string => {
  let fixedJson = msg.replaceAll(/\n/g, "\\n");
  const spTag = `P@-`;
  return fixedJson.replaceAll(spTag, `\\"`);
};

const handleCppMessage = (msg) => {
  //https://doc.weixin.qq.com/sheet/e3_AFYAlgYcABMCN07vR1bS8QsG6hm0C?scode=AJsAlAc_AAkwixt1O8AFYAlgYcABM&tab=BB08J2
  try {
    // console.log(msg);
    const fixedJson = fixJsonString(msg);
    // let fixedJson = msg.replaceAll(/\n/g, "\\n");
    // const spTag = `P@-`;
    // fixedJson = fixedJson.replaceAll(spTag, `\\"`);
    // console.log("fixedJson", fixedJson);

    const obj = JSON.parse(fixedJson);
    const cmd = obj.cmd ?? 1;
    const data = obj.data;

    if (cmd === CallbackID.SET_MODEL) {
      //model
      // handleModelCmd(data);
    } else if (cmd === CallbackID.SET_TOKEN) {
      handleTokenCmd(data);
    } else if (cmd === CallbackID.MB_SIZE) {
      handleSize(data);
    } else {
      // const { findCallbackById } = useCallbackRegistry();
      // const msgItem = findCallbackById(cmd);
      // if (!msgItem) return;
      // handleCallbackCmd(msgItem, data);
    }
  } catch (error) {
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}
}

})